import React from 'react';
import { Box, Typography } from '@mui/material';

import { HeaderDropdownMenuItemMAIQ } from './HeaderDropdownMenuItemMAIQ';

type IconColorVariant = 'primary' | 'secondary';

const getMenuItemIconSx = (iconColor: IconColorVariant) =>
  ({
    fontSize: 20,
    color: `${iconColor}.main`,
  }) as const;

const MENU_ITEM_ICON_BOX_SX = {
  minWidth: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexShrink: 0,
} as const;

type HeaderDropdownIconMenuItemMAIQProps = {
  icon: React.ReactElement;
  label: string;
  onClick: () => void;
  iconColor?: IconColorVariant;
  endAdornment?: React.ReactNode;
};

export const HeaderDropdownIconMenuItemMAIQ: React.FC<
  HeaderDropdownIconMenuItemMAIQProps
> = ({ icon, label, onClick, iconColor = 'primary', endAdornment }) => (
  <HeaderDropdownMenuItemMAIQ onClick={onClick}>
    <Box sx={MENU_ITEM_ICON_BOX_SX}>
      {React.cloneElement(icon, {
        sx: { ...getMenuItemIconSx(iconColor), ...icon.props.sx },
      })}
    </Box>
    <Typography
      component="span"
      variant="body2"
      sx={{ fontWeight: 500, fontSize: '0.875rem', flex: 1 }}
    >
      {label}
    </Typography>
    {endAdornment ?? null}
  </HeaderDropdownMenuItemMAIQ>
);

export default HeaderDropdownIconMenuItemMAIQ;
